import React from "react";
import BannerBackground from "../Assets/home-banner-background.png";
import BannerImage from "../Assets/home-banner-image.png";
import Navbar from "./Navbar";

const Home = () => {
  return (
    <div className="home-container">
      <Navbar />
      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerBackground} alt="" />
        </div>
        <div className="home-text-section">
          <h1 className="primary-heading">
            Your one stop solution for every legal need
          </h1>
          <p className="primary-text">
            Connecting the users and legal service providers providing the seamless user experience by bridging the gap
          </p>
          <button className="primary-button">
            Explore{" "}
          </button>
        </div>
        <div className="home-image-section">
         
          <img src={BannerImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Home;
